/**
* @author Camilo
* @since  15/12/2017
**/
export class UsuarioIndexModel{
	
	constructor(public cusuario:string, public cnumid:string, public nombresApellidos:string, public email:string, public cdescripcion:string, public cdescriprol:string){}

}


// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/AdministracionUsuarios/UsuarioIndex.model.ts